var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar',{attrs:{"displayLogo":false,"displayUser":true}}),_c('Menu',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}]}),_c('Information'),_c('Footer',{attrs:{"nextStep":_vm.nextStep}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }